import { RouteConfig } from "vue-router";

const condicionesComerciales: RouteConfig = {
  path: "/condicionesComerciales",
  name: "condicionesComerciales",
  component: () => import(/* webpackChunkName: "condiciones-comerciales" */ "@/views/CondicionesComerciales.vue"),
};

export default condicionesComerciales;
